import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-WI73T6NA.mjs";

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
import { forwardRef, createElement } from "react";

// ../../node_modules/lucide-react/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

// ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
var createLucideIcon = (iconName, iconNode) => {
  const Component = forwardRef(
    (_a, ref) => {
      var _b = _a, { color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, children } = _b, rest = __objRest(_b, ["color", "size", "strokeWidth", "absoluteStrokeWidth", "children"]);
      return createElement(
        "svg",
        __spreadValues(__spreadProps(__spreadValues({
          ref
        }, defaultAttributes), {
          width: size,
          height: size,
          stroke: color,
          strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
          className: `lucide lucide-${toKebabCase(iconName)}`
        }), rest),
        [
          ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
          ...(Array.isArray(children) ? children : [children]) || []
        ]
      );
    }
  );
  Component.displayName = `${iconName}`;
  return Component;
};

// ../../node_modules/lucide-react/dist/esm/icons/info.js
var Info = createLucideIcon("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/align-center.js
var AlignCenter = createLucideIcon("AlignCenter", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "17", x2: "7", y1: "12", y2: "12", key: "rsh8ii" }],
  ["line", { x1: "19", x2: "5", y1: "18", y2: "18", key: "1t0tuv" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/align-justify.js
var AlignJustify = createLucideIcon("AlignJustify", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["line", { x1: "3", x2: "21", y1: "18", y2: "18", key: "kwyyxn" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/align-left.js
var AlignLeft = createLucideIcon("AlignLeft", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
  ["line", { x1: "17", x2: "3", y1: "18", y2: "18", key: "1awlsn" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/align-right.js
var AlignRight = createLucideIcon("AlignRight", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
  ["line", { x1: "21", x2: "7", y1: "18", y2: "18", key: "1g9eri" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/arrow-up.js
var ArrowUp = createLucideIcon("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/at-sign.js
var AtSign = createLucideIcon("AtSign", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/baseline.js
var Baseline = createLucideIcon("Baseline", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/bold.js
var Bold = createLucideIcon("Bold", [
  ["path", { d: "M14 12a4 4 0 0 0 0-8H6v8", key: "v2sylx" }],
  ["path", { d: "M15 20a4 4 0 0 0 0-8H6v8Z", key: "1ef5ya" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/italic.js
var Italic = createLucideIcon("Italic", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/list.js
var List = createLucideIcon("List", [
  ["line", { x1: "8", x2: "21", y1: "6", y2: "6", key: "7ey8pc" }],
  ["line", { x1: "8", x2: "21", y1: "12", y2: "12", key: "rjfblc" }],
  ["line", { x1: "8", x2: "21", y1: "18", y2: "18", key: "c3b1m8" }],
  ["line", { x1: "3", x2: "3.01", y1: "6", y2: "6", key: "1g7gq3" }],
  ["line", { x1: "3", x2: "3.01", y1: "12", y2: "12", key: "1pjlvk" }],
  ["line", { x1: "3", x2: "3.01", y1: "18", y2: "18", key: "28t2mc" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/paperclip.js
var Paperclip = createLucideIcon("Paperclip", [
  [
    "path",
    {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
      key: "1u3ebp"
    }
  ]
]);

// ../../node_modules/lucide-react/dist/esm/icons/smile.js
var Smile = createLucideIcon("Smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/strikethrough.js
var Strikethrough = createLucideIcon("Strikethrough", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/underline.js
var Underline = createLucideIcon("Underline", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);

// ../../node_modules/lucide-react/dist/esm/icons/x.js
var X = createLucideIcon("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);

// src/theme/theme.css.ts
var vars = { color: { primary: { "light-blue": "var(--color-primary-light-blue__vve2dm0)" }, error: "var(--color-error__vve2dm1)", text: "var(--color-text__vve2dm2)", border: "var(--color-border__vve2dm3)", white: "var(--color-white__vve2dm4)", ochre: "var(--color-ochre__vve2dm5)", red: { "10": "var(--color-red-10__vve2dm6)", "20": "var(--color-red-20__vve2dm7)", "30": "var(--color-red-30__vve2dm8)", "40": "var(--color-red-40__vve2dm9)", "50": "var(--color-red-50__vve2dma)" }, gray: { "10": "var(--color-gray-10__vve2dmb)", "20": "var(--color-gray-20__vve2dmc)", "30": "var(--color-gray-30__vve2dmd)", "40": "var(--color-gray-40__vve2dme)", "50": "var(--color-gray-50__vve2dmf)", "60": "var(--color-gray-60__vve2dmg)", "70": "var(--color-gray-70__vve2dmh)" }, blue: { "10": "var(--color-blue-10__vve2dmi)", "20": "var(--color-blue-20__vve2dmj)", "30": "var(--color-blue-30__vve2dmk)", "40": "var(--color-blue-40__vve2dml)", "50": "var(--color-blue-50__vve2dmm)" }, green: { "10": "var(--color-green-10__vve2dmn)", "40": "var(--color-green-40__vve2dmo)", "50": "var(--color-green-50__vve2dmp)" }, yellow: { "10": "var(--color-yellow-10__vve2dmq)", "40": "var(--color-yellow-40__vve2dmr)", "50": "var(--color-yellow-50__vve2dms)" } } };

export {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  ArrowUp,
  AtSign,
  Baseline,
  Bold,
  Info,
  Italic,
  List,
  Paperclip,
  Smile,
  Strikethrough,
  Underline,
  X,
  vars
};
//# sourceMappingURL=chunk-P56JC6TB.mjs.map